export const infoWindowRealtyOffersPrimary = ({ payload, rgi }) => {
  const {
    building_name,
    address,
    status,
    launched_at,
    number_of_units,
    terrain_area,
    real_state_developers,
    construction_pattern,
    vgv,
    percentual_of_units_sold,
    private_area,
    btnInfo,
  } = payload;

  return `
      <style>
      .full-container{
        font-family: Quicksand;
        padding: 16px;
        width: 34rem;
        overflow: hidden;
      }
      .header {
        display: flex;
        align-items: center;
      }
      .header svg {
        margin-bottom: 15px;
      }
      .header--title{
        color: #793EAD;
        font-weight: 700;
        font-size: 1rem;
        max-width: 40ch;
        line-height: 1;    
      }
      .header--address{
        color: #525A66;
        padding-top: 5px;
        max-width: 54ch;
        font-size: 0.844rem;
      }
      .header-container {
        display: flex;
        flex-direction: column;
        margin-left: 15px;
        padding: 15px 0;
      }
      .gm-ui-hover-effect{
        top: 10px!important;
        right: 15px!important;
      }
      .gm-ui-hover-effect span {
        width: 20px!important;
        height: 20px!important;
      }
      .gm-style .gm-style-iw-c {
        padding-top: 0;
      }
      .body-container{
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        min-height: 11rem;
      }
      .body-container--info-left{
        max-width:18rem;
      }
      p.body-container--info-left--value,
      p.body-container--info-right--value {
        font: normal 0.844rem 'Open Sans', sans-serif !important;
      }
      strong {
        font: bold 0.844rem 'Open Sans', sans-serif !important;
      }
      .info-container{
        display: flex;
        flex-flow: row nowrap;
        gap: 8px;
      }
      .body-container--info-value{
        margin-left: 8px;
      }
      .infowindow-button{
        background-color: #793EAD;
        color: #FFF;
        width: 100%;
        border-radius: 4px;
        font: bold 1rem 'Quicksand', sans-serif;
        line-height: 20px;
        cursor: pointer;
        height: 2.3rem;
        border: none;
      }
      .infowindow-button:hover {
        transition: 0.2s;
        background-color: #3F205A;
      }
      </style>
      <div class="full-container">
        <div class="header">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="56" height="56" rx="28" fill="#F3F5F9"/>
            <path d="M30.17 20.7002L23 25.4802V36.0002H28V28.0002H32V36.0002H37V25.2502L30.17 20.7002Z" fill="#BA96D9"/>
            <path d="M42.8701 36H40.9087V30.6299C40.9087 30.4818 40.9108 30.2998 40.915 30.084C40.9193 29.8639 40.9256 29.6396 40.9341 29.4111C40.9425 29.1784 40.951 28.9689 40.9595 28.7827C40.9129 28.8377 40.8177 28.9329 40.6738 29.0684C40.5342 29.1995 40.403 29.318 40.2803 29.4238L39.2139 30.2808L38.2681 29.1001L41.2578 26.7197H42.8701V36Z" fill="#BA96D9"/>
            <path d="M30.5 18V19.51L28.0385 20.84L25.9092 22H24.3462V22.85L21.8846 24.19V26H19.4231V28H21.8846V30H19.4231V32H21.8846V36H17V27V18H30.5ZM19.4231 24H21.8846V22H19.4231V24Z" fill="#BA96D9"/>
          </svg>
          <div class="header-container">
            <h6 class="header--title" data-cy="ImplementarDataCY">${building_name}</h6>
            <p class="header--address" data-cy="ImplementarDataCY">${address}</p>
          </div>
        </div>
        <div class="body-container">
          <div class="body-container--info-left">
            <div class="info-container">
              <p class="body-container--info-left--key" data-cy="ImplementarDataCY"><strong>Data de lançamento:</strong></p>
              <p class="body-container--info-left--value" data-cy="ImplementarDataCY">${launched_at}</p>
            </div>
            <div class="info-container">
              <p class="body-container--info-left--key" data-cy="ImplementarDataCY"><strong>Status:</strong></p>
              <p class="body-container--info-left--value" data-cy="ImplementarDataCY">${status}</p>
            </div>
            <div class="info-container">
              <p class="body-container--info-left--key" data-cy="ImplementarDataCY"><strong>Total de Unidades:</strong></p>
              <p class="body-container--info-left--value" data-cy="ImplementarDataCY">${number_of_units}</p>
            </div>
            <div class="info-container">
              <p class="body-container--info-left--key" data-cy="ImplementarDataCY"><strong>Área de Terreno:</strong></p>
              <p class="body-container--info-left--value" data-cy="ImplementarDataCY">${terrain_area}</p>
            </div>
            <div class="info-container">
              <p class="body-container--info-left--key" data-cy="ImplementarDataCY"><strong>Incorporadora:</strong></p>
              <p class="body-container--info-left--value" data-cy="ImplementarDataCY">${real_state_developers}</p>
            </div>
          </div>
          <div class="body-container--info-right">
            <div class="info-container">
              <p class="body-container--info-right--key" data-cy="ImplementarDataCY"><strong>Padrão de construção:</strong></p>
              <p class="body-container--info-right--value" data-cy="ImplementarDataCY">${construction_pattern}</p>
            </div>
            <div class="info-container">
              <p class="body-container--info-right--key" data-cy="ImplementarDataCY"><strong>VGV:</strong></p>
              <p class="body-container--info-right--value" data-cy="ImplementarDataCY">R$${vgv}</p>
            </div>
            <div class="info-container">
              <p class="body-container--info-right--key" data-cy="ImplementarDataCY"><strong>% vendida:</strong></p>
              <p class="body-container--info-right--value" data-cy="ImplementarDataCY">${percentual_of_units_sold}</p>
            </div>
            <div class="info-container">
              <p class="body-container--info-right--key" data-cy="ImplementarDataCY"><strong>Área privativa:</strong></p>
              <p class="body-container--info-right--value" data-cy="ImplementarDataCY">${private_area}</p>
            </div>
          </div>
        </div>
        <button class="infowindow-button" id="IWButton,${rgi}" data-cy="IWBuildingDetailsButton${rgi}">Ver indicadores</button>

      </div>
      `;
};
